export enum FeatureToggle {
  catalogAdmin = 'catalogAdmin',
  catalogAdminExtractionModels = 'rt_catalog_admin_extraction_models',
  ShowQasWorkflowActions = 'rt_catalog_admin_show_qas_workflow_actions',
}
